export default import.meta.ROLLDOWN_FILE_URL_yXwY_y43guN7skkDx7d1zQ